/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { Mess } from "../../core";
import { Styles, StylesMessInternal } from "../../core/types/mess";

export const Button = styled.button(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Text = styled.p(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Image = styled.img(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Box = styled.div(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Input = styled.input(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Label = styled.label(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Ul = styled.ul(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Li = styled.li(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Footer = styled.footer(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Form = styled.form(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Span = styled.span(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const A = styled.a(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Select = styled.select(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Option = styled.option(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Header = styled.header(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Main = styled.main(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Article = styled.article(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Section = styled.section(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Aside = styled.aside(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Nav = styled.nav(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H1 = styled.h1(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H2 = styled.h2(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H3 = styled.h3(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H4 = styled.h4(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H5 = styled.h5(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const H6 = styled.h6(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Table = styled.table(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Thead = styled.thead(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Tbody = styled.tbody(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Tr = styled.tr(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Th = styled.th(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Td = styled.td(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Pre = styled.pre(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Code = styled.code(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Blockquote = styled.blockquote(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Hr = styled.hr(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Br = styled.br(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Progress = styled.progress(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Iframe = styled.iframe(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Canvas = styled.canvas(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Video = styled.video(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Audio = styled.audio(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Figure = styled.figure(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Figcaption = styled.figcaption(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Details = styled.details(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Summary = styled.summary(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Mark = styled.mark(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Time = styled.time(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Meter = styled.meter(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const B = styled.b(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const I = styled.i(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Small = styled.small(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Strong = styled.strong(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Abbr = styled.abbr(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Sub = styled.sub(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
export const Sup = styled.sup(
  ({ styles, customeclasses }: { styles?: Styles | StylesMessInternal | string; customeclasses?: string }) =>
    Mess({styles, customeclasses, usingClasses: false})
);
